import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select, DateRangePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const statusOptions = [
  { value: 'new', label: 'Baru' },
  { value: 'partial_paid', label: 'Dibayar Sebagian' },
  { value: 'paid', label: 'Lunas' },
];

const initialState = {
  schedule: null,
  document_status: null,
};

const Filter = ({ show, onClose, InvoiceTable, setCount }) => {
  const [{ schedule, document_status }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (InvoiceTable?.State?.filter) {
      let x = [];
      Object.keys(InvoiceTable?.State?.filter).forEach((k) => {
        if (
          InvoiceTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $filterDocumentStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      document_status: e,
    }));

    InvoiceTable?.filter('document_status', e?.value);
    handleFilter();
  };

  const $filterDate = (e) => {
    setState((prevState) => ({
      ...prevState,
      schedule: e,
    }));

    let fm = [];
    e?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));

    InvoiceTable?.filter('date_range', fm);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();

    let date = [];

    if (InvoiceTable?.State?.filter?.start_at && InvoiceTable?.State?.filter?.end_at) {
      date.push(new Date(InvoiceTable?.State?.filter?.start_at));
      date.push(new Date(InvoiceTable?.State?.filter?.end_at));
    }

    setState((prevState) => ({
      ...prevState,
      schedule: date,
      loading: false,
      document_status:
        InvoiceTable?.State?.filter?.document_status === 'new'
          ? statusOptions[0]
          : InvoiceTable?.State?.filter?.document_status === 'partial_paid'
          ? statusOptions[1]
          : InvoiceTable?.State?.filter?.document_status === 'paid'
          ? statusOptions[2]
          : null,
    }));
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Customer</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            params={{'type': 'customer'}}
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            initialValue={InvoiceTable?.State?.filter?.customer_id}
            onSelected={(c) => {
              InvoiceTable.filter('customer_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status Invoice
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={document_status}
            initialValue={document_status}
            options={statusOptions}
            onChange={$filterDocumentStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Tanggal Penagihan
          </div>
          <DateRangePicker
            value={schedule}
            placeholder=""
            onChange={$filterDate}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Customer</div>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{'type': 'customer'}}
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              initialValue={InvoiceTable?.State?.filter?.customer_id}
              onSelected={(c) => {
                InvoiceTable.filter('customer_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status Invoice
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={document_status}
              initialValue={document_status}
              options={statusOptions}
              onChange={$filterDocumentStatus}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tanggal Penagihan
            </div>
            <DateRangePicker
              value={schedule}
              placeholder=""
              onChange={$filterDate}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
